import { ACTION_TYPES } from "Data/Objects/ActionTypes";
import { createAction } from "@reduxjs/toolkit";

const { CLEAR_CACHE } = ACTION_TYPES.System;

export const clearCacheAction = createAction(CLEAR_CACHE);
